import React from 'react';
import { Modal, Button, Form, Input, Icon, Tabs, Table, Empty, } from 'antd';


const InputGroup = Input.Group;
const { TabPane } = Tabs;

class FormConversion extends React.Component {


  constructor(props) {
    super(props);
  }


  handleOk = (e) => {

    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      console.log(values);

      if (!err) {


        //this.props.onSaveConversion(data, this.props.form);
      }
    });
  };


  render() {

    const { getFieldDecorator, setFieldsValue, getFieldValue } = this.props.form;

    getFieldDecorator("flagReferencia", {
      initialValue: false,
    });



    return (
      <Modal
        title={"Historial Producto"}
        visible={this.props.visible}
        onCancel={this.props.onClose}
        style={{ top: 30 }}
        width={1000}
        footer={[
          <Button
            key="1"
            type='danger'
            onClick={this.props.onClose}
          >
            Aceptar
          </Button>,

        ]}
      >
        <Form>
          <div className="row">
            <div className="col-md-12 form-group">
              <Table
                style={{ overflowX: 'auto' }}
                className={'table-cuota'}
                size="small"
                pagination={false}
                dataSource={this.props.dataSource}
                rowKey={record => record.identifier}
                locale={{
                  emptyText: <Empty
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                    description='Lista vacia'
                  />
                }}
                columns={[

                  {
                    title: 'Nombre',
                    dataIndex: 'nombre',
                    key: 'nombre',
                    align: 'center'
                  },
                  /*              {
                                 title: 'Precio Promedio',
                                 dataIndex: 'precioPromedio',
                                 key: 'precioPromedio',
                                 align: 'center'
                               }, */

                  {
                    title: 'Cantidad',
                    dataIndex: 'cantidad',
                    key: 'cantidad',
                    align: 'center',
                    render: (value) => (
                      <span>{value.toFixed(2)}</span>
                    )
                  },

                  {
                    title: 'Precio Unitario',
                    dataIndex: 'precioUnitario',
                    key: 'precioUnitario',
                    align: 'center',
                    render: (value) => (
                      <span>{value.toFixed(2)}</span>
                    )
                  },
                  {
                    title: 'Cotizacion',
                    dataIndex: 'cotizacion',
                    key: 'cotizacion',
                    align: 'center'
                  },

                  {
                    title: 'Fecha',
                    dataIndex: 'fechaStr',
                    key: 'fechaStr',
                    align: 'center'
                  },
                  {
                    title: 'Referencia',
                    dataIndex: 'serieReferencia',
                    key: 'serieReferencia',
                    align: 'center'
                  },
                ]}
              />
            </div>
          </div>


        </Form>
      </Modal>
    );
  }
}

export default Form.create()(FormConversion);
